import { j as e } from "./jsx-runtime.js";
import { u as n, o as a, a as t } from "./useLinkData.js";
import { b as r } from "./utils.js";
import "react";
import "./index4.js";
import "./index2.js";
import "./util.js";
import "./index5.js";
import "./LinkDataProvider.js";
function c() {
  const { tck: o } = n(), s = () => /* @__PURE__ */ e.jsx(
    t,
    {
      hideExternalIcon: !0,
      href: r("https://www.mongodb.com/legal/terms-of-use", {
        tck: o
      }),
      children: "Terms of Use"
    }
  ), i = () => /* @__PURE__ */ e.jsx(
    t,
    {
      hideExternalIcon: !0,
      href: r(
        "https://www.mongodb.com/legal/acceptable-use-policy",
        { tck: o }
      ),
      children: "Acceptable Use Policy"
    }
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    "This is a generative AI chatbot. By interacting with it, you agree to MongoDB's ",
    /* @__PURE__ */ e.jsx(s, {}),
    " and ",
    /* @__PURE__ */ e.jsx(i, {}),
    "."
  ] });
}
function b() {
  return /* @__PURE__ */ e.jsx(a, { children: /* @__PURE__ */ e.jsx(c, {}) });
}
export {
  b as MongoDbLegalDisclosure,
  c as MongoDbLegalDisclosureText
};
